import { useState } from "react";
import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import { FramedImage } from "@/components/FramedImage";
import Lightbox from "@/components/Lightbox";
import { PHOTOS, PRICING, NOTICE, BIO } from "@/data/photos";

const TALL_VARIANTS = [
  "md:w-[48%]",
  "md:w-[50%] md:ml-auto",
  "md:w-[41%] md:mx-auto",
  "md:w-[48%] md:ml-[10%]",
];

const flowClass = (photo, i) =>
  photo.wide ? "w-full md:w-10/12 md:mx-auto" : TALL_VARIANTS[i % TALL_VARIANTS.length];

const Home = () => {
  const [active, setActive] = useState(null);

  return (
    <main data-testid="home-page">
      <Hero />

      <div className="space-y-24 px-6 pt-28 md:space-y-36 md:px-12 md:pt-40">
        {PHOTOS.map((photo, i) => (
          <figure key={photo.id} className={`group ${flowClass(photo, i)}`}>
            <button
              data-testid={`gallery-photo-${photo.id}`}
              onClick={() => setActive(i)}
              className="block w-full cursor-pointer text-left"
              aria-label={`Open photograph ${photo.title}`}
            >
              <FramedImage
                src={photo.src}
                alt={photo.title}
                natural
                ratio={photo.ratio}
                className="w-full transition-opacity duration-500 group-hover:opacity-90"
              />
            </button>
            <figcaption className="mt-4 font-body text-sm italic text-muted-foreground">
              {String(photo.id).padStart(3, "0")}
            </figcaption>
          </figure>
        ))}
      </div>

      <motion.p
        id="about"
        data-testid="home-bio"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 1.2 }}
        className="mx-auto mt-36 max-w-md px-6 text-center font-body text-sm font-light leading-loose text-muted-foreground md:mt-48 md:text-base"
      >
        {BIO}
      </motion.p>

      <motion.p
        data-testid="home-notice"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="mt-20 text-center font-body text-sm italic text-muted-foreground md:mt-24"
      >
        {NOTICE}
      </motion.p>

      <motion.p
        data-testid="home-pricing"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="mt-4 mb-32 text-center font-body text-sm italic text-muted-foreground md:mb-40"
      >
        {PRICING}
      </motion.p>

      <Lightbox
        photos={PHOTOS}
        index={active}
        onClose={() => setActive(null)}
        onNavigate={setActive}
      />
    </main>
  );
};

export default Home;
